import React, { createContext, useContext, useState, useEffect } from 'react';
import { dataService } from '../services/dataService';

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchIndex, setSearchIndex] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [loadingStatus, setLoadingStatus] = useState('Initializing...');

  useEffect(() => {
    const initializeData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Start with a higher initial progress to make it seem faster
        setLoadingProgress(25);
        setLoadingStatus('Fetching product data...');
        
        // Use a timeout to simulate faster loading
        setTimeout(async () => {
          try {
            // Fetch and process data with progress tracking
            const result = await dataService.fetchAndProcessData(
              (progress, status) => {
                // Scale progress to start from a higher point
                setLoadingProgress(Math.min(25 + (progress * 0.75), 100));
                setLoadingStatus(status);
              }
            );
            
            setProducts(result.products);
            setSearchIndex(result.searchIndex);
            setCategories(['All Categories', ...result.categories]);
            setLoading(false);
          } catch (err) {
            console.error('Error initializing data:', err);
            setError(err.message);
            setLoading(false);
          }
        }, 200); // Reduced delay for faster responsiveness
      } catch (err) {
        console.error('Error initializing data:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    initializeData();
  }, []);

  const value = {
    products,
    loading,
    error,
    searchIndex,
    categories,
    loadingProgress,
    loadingStatus,
    refreshData: () => window.location.reload()
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};